import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/work/back.png'
import _imports_1 from '../../assets/images/work/play.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-4d80b122"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "img_zone" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import ActionBar from '@/components/ActionBar/index.vue'
import { useBaseNative } from '@/utils/hooks'
import { userWorks } from '@/api/index'
import { Dialog, Toast } from 'vant'
import VConsole from 'vconsole'
import { setTimeoutSync } from '@/assets/js/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkWall',
  setup(__props) {

const route = useRoute()
const query = route.query

const { actionBarHeight, goBack, setToken } = useBaseNative()

const audioRef = ref(null)

const audio_url = ref<string>(query.audio_url as string)
const img_url = ref<string>(query.img_url as string)
const showPlay = ref<boolean>(true)

onMounted(async () => {
  if (process.env.NODE_ENV === 'development') {
    const vConsole = new VConsole()
  }
  setToken()
  const res = await userWorks({ work_id: query.unionid })
  if (res.data.code !== 0) {
    return Dialog.alert({
      message: '暂无数据'
    })
  }
  const userData = JSON.parse(res?.data?.data?.res_item_user_json)
  // const userData = [
  //   {resources_type: 1, img_url: 'xxx.png'},
  //   {resources_type: 2, audio_url: '', resources_play_time: 0}
  // ]
  console.log(userData)
  userData?.forEach((item) => {
    if (item.resources_type === 1) {
      img_url.value = item.img_url
    }
    if (item.resources_type === 2) {
      audio_url.value = item.audio_url
    }
  })

  await setTimeoutSync()
  if(audio_url.value) {
      audioRef.value.addEventListener('ended', function () {
    showPlay.value = true
  }, false)
  } else {
    Toast('音频资源获取失败')
  }

})

const play = () => {
  if(!audio_url.value) {
    return  Toast('音频资源获取失败')
  }
  audioRef.value.play()
  showPlay.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(goBack) && _unref(goBack)(...args))),
      class: "back",
      src: _imports_0,
      alt: "",
      srcset: ""
    }),
    _createElementVNode("img", {
      class: "bg",
      src: img_url.value,
      alt: ""
    }, null, 8, _hoisted_2),
    (audio_url.value)
      ? (_openBlock(), _createElementBlock("audio", {
          key: 0,
          ref_key: "audioRef",
          ref: audioRef,
          preload: ""
        }, [
          _createElementVNode("source", {
            id: "my-player",
            src: audio_url.value,
            type: "audio/mpeg"
          }, null, 8, _hoisted_3),
          _createTextVNode(" 您的浏览器不支持 audio 元素。 ")
        ], 512))
      : _createCommentVNode("", true),
    (showPlay.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          onClick: play,
          class: "play",
          src: _imports_1,
          alt: "",
          srcset: ""
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})